// import React from 'react'
// import { Grid, GridItem, Box, Heading, Text } from '@chakra-ui/react'
// import Card from 'components/card/Card'
// import moment from 'moment'
// import { HSeparator } from "components/separator/Separator";

// const CustomView = ({ data, toCamelCase, fieldData }) => {

//     const headingLength = data?.headings?.length % 3
//     const headingLengthMd = data?.headings?.length % 2
//     const lastLength = data?.headings.length - headingLength
//     const lastLengthMd = data?.headings.length - headingLengthMd

//     // Define a function to determine the colSpan value
//     const getColSpanLg = (ind, lastLength, headingLength) => {
//         if (ind < lastLength) {
//             return (ind + 1) > lastLength ? 6 : 4;
//         } else {
//             return headingLength === 1 ? 12 : ((ind + 1) > lastLength ? 6 : 4);
//         }
//     };
//     const getColSpanMd = (ind, lastLengthMd, headingLengthMd) => {
//         if (ind < lastLengthMd) {
//             return (ind + 1) > lastLengthMd ? 4 : 6;
//         } else {
//             return headingLengthMd === 1 ? 12 : ((ind + 1) > lastLengthMd ? 4 : 6);
//         }
//     };
//     return (
//         <Grid templateColumns="repeat(12, 1fr)" gap={3}>
//             {data?.headings?.length > 0 ? <>
//                 {data?.headings?.map((item, ind) => (
//                     <>
//                         <GridItem colSpan={{
//                             base: 12, md: getColSpanMd(ind, lastLengthMd, headingLengthMd), lg: getColSpanLg(ind, lastLength, headingLength)
//                         }} key={ind}>
//                             <Card>
//                                 <Grid templateColumns="repeat(12, 1fr)" gap={3}>
//                                     <GridItem colSpan={12}>
//                                         <Heading as="h1" size="md" mb='10px'>
//                                             {ind + 1}. {item?.heading}
//                                         </Heading>
//                                         <HSeparator />
//                                     </GridItem>
//                                     {
//                                         data?.fields?.filter((itm) => itm?.belongsTo === item?._id)?.map((field) => (
//                                             <GridItem colSpan={{ base: 12, md: 6 }} key={field?.name}>
//                                                 <Text color={'blackAlpha.900'} fontSize="sm" fontWeight="bold"> {field?.label}</Text>
//                                                 <Text color={'blackAlpha.900'} fontSize="sm" > {(fieldData && (fieldData[field?.name] !== undefined ? fieldData[field?.name] : "N/A")) || "N/A"}</Text>
//                                             </GridItem>
//                                         ))
//                                     }
//                                 </Grid>
//                             </Card>
//                         </GridItem>
//                     </>)
//                 )}
//             </> :
//                 <GridItem colSpan={{
//                     base: 12,
//                 }}>

//                     <Card>
//                         <Grid templateColumns="repeat(12, 1fr)" gap={3}>
//                             <GridItem colSpan={12}>
//                                 <Heading as="h1" size="md" mb='10px'>
//                                     {data?.moduleName} view page
//                                 </Heading>
//                                 <HSeparator />
//                             </GridItem>
//                             {
//                                 data?.fields?.map((field) => (
//                                     <GridItem colSpan={{ base: 12, md: 6 }} key={field?.name}>
//                                         <Text color={'blackAlpha.900'} fontSize="sm" fontWeight="bold"> {field?.label}</Text>
//                                         <Text color={'blackAlpha.900'} fontSize="sm" > {(fieldData && (fieldData[field?.name] !== undefined ? fieldData[field?.name] : "N/A")) || "N/A"}</Text>
//                                     </GridItem>
//                                 ))
//                             }
//                         </Grid>
//                     </Card>
//                 </GridItem>
//             }
//         </Grid>
//     )
// }

// export default CustomView
// import React from "react";
import React from 'react';
import { Grid, GridItem, Box, Heading, Text } from '@chakra-ui/react';
import Card from 'components/card/Card';
import moment from 'moment';
import { HSeparator } from 'components/separator/Separator';

const CustomView = ({ data, toCamelCase, fieldData }) => {
  //console.log(data);

  if (!data || !Array.isArray(data.headings) || !Array.isArray(data.fields)) {
    return <Text color='red.500'>Error: No valid data available</Text>;
  }

  // Function to format comment data
  const formatCommentData = (array) => {
    return array.map(({ comment, createdAt }) => 
      `comment: ${comment}, Created At: ${moment(createdAt).format("YYYY-MM-DD [at] HH:mm")}`
    );
  };

  return (
    <Grid templateColumns="repeat(12, 1fr)" gap={3}>
      {data.headings.length > 0 ? (
        data.headings.map((item, ind) => (
          <GridItem colSpan={{ base: 12, md: 6, lg: 4 }} key={ind}>
            <Card>
              <Grid templateColumns="repeat(12, 1fr)" gap={3}>
                <GridItem colSpan={12}>
                  <Heading as="h1" size="md" mb="10px">
                    {ind + 1}. {item?.heading || "No Heading"}
                  </Heading>
                  <HSeparator />
                </GridItem>

                {data.fields.map((field) => (
                  <GridItem colSpan={{ base: 12, md: 6 }} key={field?.name}>
                    <Text color={"blackAlpha.900"} fontSize="sm" fontWeight="bold">
                      {field?.label || "No Label"}
                    </Text>

                    {Array.isArray(fieldData?.[field?.name]) && field?.type === "array" ? (
                      fieldData[field?.name].length > 0 ? (
                        <Box p={2} border="1px solid gray" borderRadius="md">
                          {fieldData[field?.name].map((item, index) => (
                            <Box key={index} p={2} borderBottom="1px solid gray">
                              {typeof item === "object" && item !== null ? (
                                Object.entries(item).map(([key, value]) => (
                                  <Text key={key} color={"blackAlpha.900"} fontSize="sm">
                                    <strong>{toCamelCase ? toCamelCase(key) : key}:</strong>{" "}
                                    {key === "createdAt" 
                                      ? moment(value).format("YYYY-MM-DD [at] HH:mm") 
                                      : value || "N/A"}
                                  </Text>
                                ))
                              ) : (
                                <Text color={"blackAlpha.900"} fontSize="sm">
                                  {item || "N/A"}
                                </Text>
                              )}
                            </Box>
                          ))}
                        </Box>
                      ) : (
                        <Text color={"blackAlpha.600"} fontSize="sm">No Data Available</Text>
                      )
                    ) : (
                      <Text color={"blackAlpha.900"} fontSize="sm">
                        {fieldData?.[field?.name] !== undefined ? (
                          Array.isArray(fieldData[field?.name])
                            ? formatCommentData(fieldData[field?.name]).map((formattedText, idx) => (
                                <Text key={idx} color={"blackAlpha.900"} fontSize="sm">
                                  {formattedText}
                                </Text>
                              ))
                            : fieldData[field?.name]
                        ) : "N/A"}
                      </Text>
                    )}
                  </GridItem>
                ))}
              </Grid>
            </Card>
          </GridItem>
        ))
      ) : (
        <GridItem colSpan={{ base: 12 }}>
          <Card>
            <Grid templateColumns="repeat(12, 1fr)" gap={3}>
              <GridItem colSpan={12}>
                <Heading as="h1" size="md" mb="10px">
                  {data?.moduleName || "Module Name"} view page
                </Heading>
                <HSeparator />
              </GridItem>
              {data.fields.map((field) => (
                <GridItem colSpan={{ base: 12, md: 6 }} key={field?.name}>
                  <Text color={"blackAlpha.900"} fontSize="sm" fontWeight="bold">
                    {field?.label || "No Label"}
                  </Text>
                  <Text color={"blackAlpha.900"} fontSize="sm">
                    {fieldData?.[field?.name] !== undefined ? (
                      Array.isArray(fieldData[field?.name])
                        ? formatCommentData(fieldData[field?.name]).map((formattedText, idx) => (
                            <Text key={idx} color={"blackAlpha.900"} fontSize="sm">
                              {formattedText}
                            </Text>
                          ))
                        : fieldData[field?.name]
                    ) : "N/A"}
                  </Text>
                </GridItem>
              ))}
            </Grid>
          </Card>
        </GridItem>
      )}
    </Grid>
  );
};

export default CustomView;
